import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileAwardRow from "../../profiles/components/ProfileAwardRow";

export default class AwardForm extends ProfileItemForm {

    static ItemType = 'Award'

    static FormClass = 'talent-role-form add-talent-form add-award-form '
    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fas fa-trophy',
        color: TB.config('color.warning')
    }
    /**
     * The fields mapping for the form
     */
    formFields = () => {

        // 'awards.*.year'           => 'required|integer|max:'.now()->year.'|min:1950',
        // 'awards.*.name'           => 'required|string|max:255',
        // 'awards.*.url'            => 'nullable|string|url|max:255',
        // 'awards.*.image_path'     => 'nullable|string|max:255' OR 'nullable|image',
        // 'awards.*.description'    => 'nullable|string|max:255',

        return [
            {
                style: styles.fieldSection,
                fields: {
                    name: {
                        type: 'text',
                        label: TB.trans('talent.award_form.award_name_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.award_form.award_name_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    year: {
                        label   : TB.trans('talent.award_form.year_label'),
                        placeholder   : TB.trans('talent.award_form.year_placeholder'),
                        type    : 'select',
                        required: true,
                        options: this.yearOptions(),
                        style   : styles.field,
                        columns: 10
                    },
                }
            },
            {
                style: styles.fieldSection,

                fields: {
                    url: {
                        label: TB.trans('talent.award_form.award_url_label'),
                        placeholder: TB.trans('talent.award_form.award_url_placeholder'),
                        type: 'url',
                        maxLength: 255,
                        required: false,
                        style: styles.field,
                        columns: 5
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: TB.trans('talent.award_form.award_logo_label'),
                        type: 'pixie',
                        maxWidth: 300,
                        // height: 150,
                        ratio: '1:1',
                        circular: false,
                        required: false,
                        style: styles.field,
                        columns: 8
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    description: {
                        label: TB.trans('talent.award_form.summary_paragraph_label'),
                        placeholder: TB.trans('talent.award_form.summary_paragraph_placeholder'),
                        type: 'textarea',
                        required: false,
                        style: styles.field,
                        maxLength: 10000,
                        columns: 10,
                        rows: 10
                    },
                }
            },
        ]
    };

    renderProfilePreview() {
        return (
            <div className="px-4 mx-0 self-start">
                <ProfileAwardRow award={this.getModelFromProps()}/>
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};